export default __webpack_public_path__ + "static/media/emptyBetslip.4e5ce2d0.png";